// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.custom-modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(18, 18, 18, 0.65);
  display: none;
  align-items: center;
  justify-content: center;
  z-index: 1050;
  transition: opacity 0.3s ease-in-out;
}
.custom-modal.show {
  display: flex;
  opacity: 1;
}
.custom-modal .custom-modal-dialog {
  width: 600px;
  max-width: 95%;
  background: #fff;
  border-radius: 16px;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.25);
  overflow: hidden;
  animation: scaleIn 0.3s ease;
}
.custom-modal .custom-modal-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0.2rem 1.5rem;
  background: linear-gradient(135deg, #1571b9, #00a6ff);
  border-bottom: 1px solid #e4e4e4;
}
.custom-modal .custom-modal-header .title {
  font-size: 1.2rem;
  font-weight: 600;
  color: #fff;
  margin-top: 10px;
  margin-bottom: 10px;
}
.custom-modal .custom-modal-header .close-btn {
  background: transparent;
  border: none;
  color: #666;
  font-size: 1.1rem;
  cursor: pointer;
}
.custom-modal .custom-modal-header .close-btn:hover {
  color: #000;
}
.custom-modal .custom-modal-body {
  padding: 1.5rem;
}
.custom-modal .custom-modal-body .form-row {
  margin-bottom: 1rem;
  display: flex;
  flex-direction: column;
}
.custom-modal .custom-modal-body .form-row label {
  font-weight: 500;
  margin-bottom: 0.3rem;
  color: #444;
}
.custom-modal .custom-modal-body .form-row label .required {
  color: #e53935;
}
.custom-modal .custom-modal-body .form-row label small {
  float: right;
  font-size: 0.8rem;
  color: #1571b9;
}
.custom-modal .custom-modal-body .form-row .input,
.custom-modal .custom-modal-body .form-row .textarea,
.custom-modal .custom-modal-body .form-row .select {
  border-radius: 8px;
  border: 1px solid #ddd;
  padding: 0.6rem 0.75rem;
  font-size: 0.95rem;
  transition: all 0.2s;
}
.custom-modal .custom-modal-body .form-row .input:focus,
.custom-modal .custom-modal-body .form-row .textarea:focus,
.custom-modal .custom-modal-body .form-row .select:focus {
  outline: none;
  border-color: #1571b9;
  box-shadow: 0 0 0 2px rgba(0, 102, 255, 0.1);
}
.custom-modal .custom-modal-body .user-list-container {
  max-height: 160px;
  overflow-y: auto;
  border-radius: 8px;
  padding: 0.5rem;
  background: #fafafa;
}
.custom-modal .custom-modal-body .user-list-container .no-users {
  text-align: center;
  padding: 1rem;
  color: #999;
}
.custom-modal .custom-modal-body .user-list-container .user-list {
  list-style: none;
  padding: 0;
  margin: 0;
}
.custom-modal .custom-modal-body .user-list-container .user-list .user-item {
  display: flex;
  align-items: center;
  padding: 0.6rem 0.75rem;
  border-radius: 8px;
  cursor: pointer;
  transition: background 0.2s ease;
}
.custom-modal .custom-modal-body .user-list-container .user-list .user-item:hover {
  background: #f0f7ff;
}
.custom-modal .custom-modal-body .user-list-container .user-list .user-item.selected {
  background: #e3f2ff;
  border-left: 2px solid #1571b9;
}
.custom-modal .custom-modal-body .user-list-container .user-list .user-item .user-icon {
  margin-right: 10px;
  color: #555;
}
.custom-modal .custom-modal-body .user-list-container .user-list .user-item .user-name {
  flex: 1;
  font-size: 0.95rem;
}
.custom-modal .custom-modal-body .user-list-container .user-list .user-item .check-icon {
  color: #1571b9;
}
.custom-modal .custom-modal-footer {
  display: flex;
  justify-content: flex-end;
  gap: 1rem;
  padding: 1rem 1.5rem;
  border-top: 1px solid #eaeaea;
  background: #f9fafc;
}
.custom-modal .custom-modal-footer .btn {
  border: none;
  padding: 0.5rem 1.2rem;
  border-radius: 6px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
}
.custom-modal .custom-modal-footer .btn.btn-cancel {
  background: #e4e6eb;
  color: #333;
}
.custom-modal .custom-modal-footer .btn.btn-cancel:hover {
  background: #d6d8dc;
}
.custom-modal .custom-modal-footer .btn.btn-primary {
  background: #1571b9;
  color: #fff;
}
.custom-modal .custom-modal-footer .btn.btn-primary:disabled {
  background: #9fbdfc;
  cursor: not-allowed;
}
.custom-modal .custom-modal-footer .btn.btn-primary:hover:not(:disabled) {
  background: #1571b9;
}

@keyframes scaleIn {
  from {
    transform: scale(0.95);
    opacity: 0.8;
  }
  to {
    transform: scale(1);
    opacity: 1;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/components/elibraryandcourse/e-library/new-course/new-course.component.scss"],"names":[],"mappings":"AA+EA;EACE,eAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,kCAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,aAAA;EACA,oCAAA;AA9EF;AAgFE;EACE,aAAA;EACA,UAAA;AA9EJ;AAiFE;EACE,YAAA;EACA,cAAA;EACA,gBAAA;EACA,mBAAA;EACA,2CAAA;EACA,gBAAA;EACA,4BAAA;AA/EJ;AAkFE;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,sBAAA;EACA,qDAAA;EACA,gCAAA;AAhFJ;AAkFI;EACE,iBAAA;EACA,gBAAA;EACA,WAAA;EACA,gBAAA;EACA,mBAAA;AAhFN;AAmFI;EACE,uBAAA;EACA,YAAA;EACA,WAAA;EACA,iBAAA;EACA,eAAA;AAjFN;AAmFM;EACE,WAAA;AAjFR;AAsFE;EACE,eAAA;AApFJ;AAsFI;EACE,mBAAA;EACA,aAAA;EACA,sBAAA;AApFN;AAsFM;EACE,gBAAA;EACA,qBAAA;EACA,WAAA;AApFR;AAsFQ;EACE,cAAA;AApFV;AAuFQ;EACE,YAAA;EACA,iBAAA;EACA,cAAA;AArFV;AAyFM;;;EAGE,kBAAA;EACA,sBAAA;EACA,uBAAA;EACA,kBAAA;EACA,oBAAA;AAvFR;AAyFQ;;;EACE,aAAA;EACA,qBAAA;EACA,4CAAA;AArFV;AA0FI;EACE,iBAAA;EACA,gBAAA;EAEA,kBAAA;EACA,eAAA;EACA,mBAAA;AAzFN;AA2FM;EACE,kBAAA;EACA,aAAA;EACA,WAAA;AAzFR;AA4FM;EACE,gBAAA;EACA,UAAA;EACA,SAAA;AA1FR;AA4FQ;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,eAAA;EACA,gCAAA;AA1FV;AA4FU;EACE,mBAAA;AA1FZ;AA6FU;EACE,mBAAA;EACA,8BAAA;AA3FZ;AA8FU;EACE,kBAAA;EACA,WAAA;AA5FZ;AA+FU;EACE,OAAA;EACA,kBAAA;AA7FZ;AAgGU;EACE,cAAA;AA9FZ;AAqGE;EACE,aAAA;EACA,yBAAA;EACA,SAAA;EACA,oBAAA;EACA,6BAAA;EACA,mBAAA;AAnGJ;AAqGI;EACE,YAAA;EACA,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,yBAAA;AAnGN;AAqGM;EACE,mBAAA;EACA,WAAA;AAnGR;AAqGQ;EACE,mBAAA;AAnGV;AAuGM;EACE,mBAAA;EACA,WAAA;AArGR;AAuGQ;EACE,mBAAA;EACA,mBAAA;AArGV;AAwGQ;EACE,mBAAA;AAtGV;;AA6GA;EACE;IACE,sBAAA;IACA,YAAA;EA1GF;EA6GA;IACE,mBAAA;IACA,UAAA;EA3GF;AACF","sourcesContent":["// .notification-content-wrapper{\n//     height:calc(100vh - 200px);\n//     overflow-y: auto;\n// }\n\n// .modal-dialog{\n//     .modal-content{\n//         max-width:calc(100vw - 50px);\n//     }\n//     .modal-header{\n//         justify-content: space-between;\n//     }\n//     .modal-body{\n//       height:calc(100vh - 150px);\n//         overflow-y: auto;\n//         scrollbar-width: none;\n//     }\n//     .fa-solid{\n//         font-size:1.5rem !important;\n//         color:#fff !important;\n//     }\n// }\n// .modal.fade{\n//     background:rgba(0,0,0,0.2);\n// }\n// .modal.show{\n//     display: block;\n// }\n// .modal-header{\n//     background: var(--primaryColor);\n//     color:#fff;\n// }\n// .btn-close{\n//     color: #fff;\n// }\n// .userlist{\n//     height:calc(100vh - 500px);\n//     overflow-y: auto;\n//     .user-icon{\n//         .fa-solid{\n//            color: #bababa !important;\n//            margin-right: 10px;\n//         }\n//     }\n// }\n// .btn-primary{\n//     background: var(--primaryColor) !important;\n//     color:#fff !important;\n// }\n// .btn-cancel{\n//     background-color:#eee;\n//     color:#111;\n// }\n// .btn{\n//     padding:.3rem .8rem !important;\n// }\n\n// .list-group{\n//     li{\n//         cursor: pointer;\n\n\n//     }\n//     li:hover{\n//              background: var(--listbackgoundhover) !important;\n//            color: var(--listcolor) !important;\n//         }\n//     .user-icon{\n//         margin-right:10px;\n//     }\n//     li.active-bg{\n//         background: var(--listbackgoundhover) !important;\n//         color: var(--listcolor) !important;\n//       border-bottom: 1px solid #4bf768 !important;\n//         .fa{\n//            color: var(--listcolor) !important;\n//         }\n//     }\n// }\n.custom-modal {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background: rgba(18, 18, 18, 0.65);\n  display: none;\n  align-items: center;\n  justify-content: center;\n  z-index: 1050;\n  transition: opacity 0.3s ease-in-out;\n\n  &.show {\n    display: flex;\n    opacity: 1;\n  }\n\n  .custom-modal-dialog {\n    width: 600px;\n    max-width: 95%;\n    background: #fff;\n    border-radius: 16px;\n    box-shadow: 0 10px 40px rgba(0, 0, 0, 0.25);\n    overflow: hidden;\n    animation: scaleIn 0.3s ease;\n  }\n\n  .custom-modal-header {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    padding: 0.2rem 1.5rem;\n    background: linear-gradient(135deg, #1571b9, #00a6ff);\n    border-bottom: 1px solid #e4e4e4;\n\n    .title {\n      font-size: 1.2rem;\n      font-weight: 600;\n      color: #fff;\n      margin-top: 10px;\n      margin-bottom: 10px;\n    }\n\n    .close-btn {\n      background: transparent;\n      border: none;\n      color: #666;\n      font-size: 1.1rem;\n      cursor: pointer;\n\n      &:hover {\n        color: #000;\n      }\n    }\n  }\n\n  .custom-modal-body {\n    padding: 1.5rem;\n\n    .form-row {\n      margin-bottom: 1rem;\n      display: flex;\n      flex-direction: column;\n\n      label {\n        font-weight: 500;\n        margin-bottom: 0.3rem;\n        color: #444;\n\n        .required {\n          color: #e53935;\n        }\n\n        small {\n          float: right;\n          font-size: 0.8rem;\n          color: #1571b9;\n        }\n      }\n\n      .input,\n      .textarea,\n      .select {\n        border-radius: 8px;\n        border: 1px solid #ddd;\n        padding: 0.6rem 0.75rem;\n        font-size: 0.95rem;\n        transition: all 0.2s;\n\n        &:focus {\n          outline: none;\n          border-color: #1571b9;\n          box-shadow: 0 0 0 2px rgba(0, 102, 255, 0.1);\n        }\n      }\n    }\n\n    .user-list-container {\n      max-height: 160px;\n      overflow-y: auto;\n      // border: 1px solid #e0e0e0;\n      border-radius: 8px;\n      padding: 0.5rem;\n      background: #fafafa;\n\n      .no-users {\n        text-align: center;\n        padding: 1rem;\n        color: #999;\n      }\n\n      .user-list {\n        list-style: none;\n        padding: 0;\n        margin: 0;\n\n        .user-item {\n          display: flex;\n          align-items: center;\n          padding: 0.6rem 0.75rem;\n          border-radius: 8px;\n          cursor: pointer;\n          transition: background 0.2s ease;\n\n          &:hover {\n            background: #f0f7ff;\n          }\n\n          &.selected {\n            background: #e3f2ff;\n            border-left: 2px solid #1571b9;\n          }\n\n          .user-icon {\n            margin-right: 10px;\n            color: #555;\n          }\n\n          .user-name {\n            flex: 1;\n            font-size: 0.95rem;\n          }\n\n          .check-icon {\n            color: #1571b9;\n          }\n        }\n      }\n    }\n  }\n\n  .custom-modal-footer {\n    display: flex;\n    justify-content: flex-end;\n    gap: 1rem;\n    padding: 1rem 1.5rem;\n    border-top: 1px solid #eaeaea;\n    background: #f9fafc;\n\n    .btn {\n      border: none;\n      padding: 0.5rem 1.2rem;\n      border-radius: 6px;\n      font-weight: 500;\n      cursor: pointer;\n      transition: all 0.2s ease;\n\n      &.btn-cancel {\n        background: #e4e6eb;\n        color: #333;\n\n        &:hover {\n          background: #d6d8dc;\n        }\n      }\n\n      &.btn-primary {\n        background: #1571b9;\n        color: #fff;\n\n        &:disabled {\n          background: #9fbdfc;\n          cursor: not-allowed;\n        }\n\n        &:hover:not(:disabled) {\n          background: #1571b9;\n        }\n      }\n    }\n  }\n}\n\n@keyframes scaleIn {\n  from {\n    transform: scale(0.95);\n    opacity: 0.8;\n  }\n\n  to {\n    transform: scale(1);\n    opacity: 1;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
